import React from 'react';
import FontAwesome from 'react-fontawesome';



class UserImageSelectItem extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            imageError: false
        }

        this.handleImageError = this.handleImageError.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleSelect(e) {
        e.preventDefault();
        this.props.onUserImageSelect(this.props.image);
    }

    handleEdit(e) {
        e.preventDefault();
        this.props.onUserImageEdit(this.props.image);
    }

    handleRemove(e) {
        e.preventDefault();
        this.props.onUserImageRemove(this.props.image);
    }


    handleImageError() {
        this.setState({imageError: true});
    }

    render() {

        if (this.state.imageError)
            return null;

        return (
            <div className="userimage_select_item">
                <div className="row">
                    <div className="col-xs-12">
                        <a href="#" onClick={this.handleSelect}>
                            <img
                                onLoad={this.handleImageLoaded}
                                onError={this.handleImageError}
                                src={this.props.image.getImageUrl()}
                                alt=""
                                title={'Bild einfügen (klick mich)'}
                            />
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <button type="button" onClick={this.handleRemove} className="btn btn-primary btn-lg btn-block"> <FontAwesome name='trash' /></button>
                    </div>
                    <div className="col-xs-6">
                        <button type="button" onClick={this.handleEdit} className="btn btn-primary btn-lg btn-block"> <FontAwesome name='pencil'/></button>
                    </div>
                </div>

            </div>
        );
    }
}

export default UserImageSelectItem;



// WEBPACK FOOTER //
// ./src/UserImageSelectItem.js